/**
 * How an invoice treats VAT (`invoices.vatMode`); every mode but standard charges none. A module
 * without imports, so services/mcp can bundle it with the VAT notes.
 */
export const VAT_MODES = [
  "standard",
  "small_business",
  "reverse_charge",
  "intra_eu",
  "export",
  "exempt",
] as const;
export type VatMode = (typeof VAT_MODES)[number];
